import { render, staticRenderFns } from "./OnboardingBoard.vue?vue&type=template&id=b53b5836&scoped=true"
import script from "./OnboardingBoard.vue?vue&type=script&lang=js"
export * from "./OnboardingBoard.vue?vue&type=script&lang=js"
import style0 from "./OnboardingBoard.vue?vue&type=style&index=0&id=b53b5836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b5836",
  null
  
)

export default component.exports